// extracted by mini-css-extract-plugin
export default {"loading":"loading-loading-DrxW0I","pulse":"loading-pulse-qQUU7m","bounce":"loading-bounce-sm8rTv","dark":"loading-dark-_xGHw1"};